import { motion } from "framer-motion";

// OCTON neural mark - a synaptic node firing across a network. AI-neuroscience theme.
export function OctonLogo({ size = 34, glow = true }) {
  const nodes = [
    [24, 6], [40, 15], [40, 33], [24, 42], [8, 33], [8, 15],
  ];
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"
      style={glow ? { filter: "drop-shadow(0 0 6px rgba(204,255,0,0.55))" } : undefined}>
      <defs>
        <radialGradient id="octonCore" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#EFFFA8" />
          <stop offset="55%" stopColor="#CCFF00" />
          <stop offset="100%" stopColor="#5c7300" />
        </radialGradient>
      </defs>

      {/* rotating synaptic ring */}
      <motion.circle cx="24" cy="24" r="21" stroke="#0047FF" strokeWidth="1.2"
        strokeDasharray="4 6" opacity="0.55"
        animate={{ rotate: 360 }} transition={{ duration: 14, repeat: Infinity, ease: "linear" }}
        style={{ transformOrigin: "24px 24px" }} />

      {/* dendrite connections */}
      {nodes.map(([x, y], i) => (
        <line key={`l${i}`} x1="24" y1="24" x2={x} y2={y} stroke="#0047FF" strokeWidth="1.4" opacity="0.5" />
      ))}
      {/* inter-node synapses */}
      {nodes.map(([x, y], i) => {
        const [nx, ny] = nodes[(i + 1) % nodes.length];
        return <line key={`s${i}`} x1={x} y1={y} x2={nx} y2={ny} stroke="#CCFF00" strokeWidth="1" opacity="0.28" />;
      })}

      {/* firing node pulses */}
      {nodes.map(([x, y], i) => (
        <motion.circle key={`n${i}`} cx={x} cy={y} r="2.6" fill="#CCFF00"
          style={{ transformBox: "fill-box", transformOrigin: "center" }}
          animate={{ opacity: [0.35, 1, 0.35], scale: [0.85, 1.15, 0.85] }}
          transition={{ duration: 2.4, repeat: Infinity, delay: i * 0.35, ease: "easeInOut" }} />
      ))}

      {/* soma / core */}
      <motion.circle cx="24" cy="24" r="7" fill="url(#octonCore)"
        style={{ transformBox: "fill-box", transformOrigin: "center" }} animate={{ scale: [0.92, 1.06, 0.92] }} transition={{ duration: 2.6, repeat: Infinity, ease: "easeInOut" }} />
      <circle cx="24" cy="24" r="3" fill="#0b0e05" opacity="0.85" />
      <circle cx="24" cy="24" r="1.4" fill="#CCFF00" />
    </svg>
  );
}
